import { shouldRefreshAuthToken } from './should-refresh-auth-token';
/**
 * Creates an [[OcapiAuthTokenProvider]] instance with caching to prevent unnecessary API calls.
 */
export const createOcapiAuthTokenProvider = (authTokenProvider) => {
    let authToken;
    let authTokenPromise;
    const getAuthToken = async () => {
        // Clear the cached token if it needs to be refreshed.
        const refresh = authToken ? shouldRefreshAuthToken(authToken) : false;
        if (refresh) {
            authToken = undefined;
        }
        // Get the token from the configured provider and cache it to prevent unnecessary API calls.
        if (!authToken) {
            authToken = await authTokenProvider(refresh);
        }
        return authToken;
    };
    return async () => {
        // Return the cached promise to prevent duplicate API calls.
        if (!authTokenPromise) {
            authTokenPromise = getAuthToken();
        }
        const token = await authTokenPromise;
        // Clear the cached promise and return the auth token.
        authTokenPromise = undefined;
        return token;
    };
};
//# sourceMappingURL=create-ocapi-auth-token-provider.js.map